import { useDispatch } from "react-redux"
import { addToWishList, removeWishListItem } from "../Redux/features/WishList/WishlistSlice"
import { useContext } from "react";
import { ConfigContext } from "../Context/ConfigContext";

const GlobalCards = ({ item, handleProductDetails, handleAddToCart, CheckWishList }) => {
    const dispatch = useDispatch();
    const { currency, currencyValue } = useContext(ConfigContext)

    const getStarPercent = (rating) => {
        return (rating / 5) * 100;
    };

    const handleAddToWishList = () => {
        const newProduct = { ...item, selected_currency: currencyValue }
        dispatch(addToWishList(newProduct))
    }

    return (
        <div key={item.product_id} className="col-lg-1-5 col-md-4 col-12 col-sm-6" >
            <div className="product-cart-wrap mb-30 wow animate__animated animate__fadeIn" data-wow-delay=".1s">
                <div className="product-img-action-wrap">
                    <div className="product-img product-img-zoom">
                        <a>
                            <img
                                className="default-img"
                                onClick={handleProductDetails}
                                src={item.product_image_url}
                                loading='lazy'
                                alt=""
                            />
                            <img
                                className="hover-img"
                                onClick={handleProductDetails}
                                src={item.product_image_url}
                                loading='lazy'
                                alt=""
                            />
                        </a>
                    </div>
                    <div className="product-action-1">
                        {
                            CheckWishList ?
                                (
                                    <a
                                        onClick={() => dispatch(removeWishListItem(item.product_id))}
                                        aria-label={`Remove From Wishlist`} className="action-btn"
                                        style={{ background: '#FDC040' }} >
                                        <i style={{ color: '#fff' }} className="fi-rs-heart" />
                                    </a>
                                ) :
                                <a
                                    onClick={() => handleAddToWishList()}
                                    aria-label={`Add To Wishlist`}
                                    className="action-btn" >
                                    <i className="fi-rs-heart" />
                                </a>
                        }
                    </div>
                    <div className="product-badges product-badges-position product-badges-mrg">
                        {
                            item?.product_label &&
                            <span className={item?.product_label_class}>{item?.product_label}</span>
                        }
                    </div>
                </div>
                <div className="product-content-wrap" >
                    <div className="product-description">
                        <h2>
                            <a>
                                <div
                                    onClick={handleProductDetails}
                                    className={`expandable-text`}
                                // style={{ marginTop: "20" }}
                                >
                                    <a style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{item?.product_title}</a>
                                </div>
                            </a>
                        </h2>
                    </div>
                    <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                            <div className="product-rating" style={{ width: getStarPercent(item?.average_rating) + '%' }} />
                        </div>
                        <span className="font-small ml-5 text-muted">{item?.average_rating}</span>
                    </div>
                    <div>
                        <span className="font-small text-muted">Specification :  <a>
                            {item.product_short_description.slice(0, 30) + (item.product_short_description.length > 30 ? "..." : "")}
                        </a>
                        </span>
                    </div>
                    <div className="product-card-bottom">
                        {item.product_stock_status !== 0 && (
                            <div className="product-price">
                                <span>{currency} {item.product_variant_sale_price}</span>
                                <span className="old-price">{currency} {item.product_variant_mrp_price}</span>
                            </div>
                        )}
                        <div className="add-cart">
                            {item.product_stock_status === 0 ? (
                                <span className="stock-status out-stock mb-0"> Out Stock </span>
                            ) : (
                                <span className="add" onClick={() => handleAddToCart(item)}>
                                    <i className="fi-rs-shopping-cart mr-5" />Add
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GlobalCards